/**
 * What the safety feed last put on the boards, where the shell can read it.
 *
 * Imports nothing, for the reason `report.ts` gives: the shell reads it on
 * every screen, and reading it from the merge would pull the demo's tables
 * into the entry chunk.
 */

export interface SafetyFeedReport {
  /** null until the feed has merged anything */
  hazards: number | null;
  reports: number | null;
  incidents: number | null;
  /** what the platform would not let this person read, said in its words */
  refused: string[];
}

const empty = (): SafetyFeedReport => ({ hazards: null, reports: null, incidents: null, refused: [] });

let report = empty();
const listeners = new Set<() => void>();

export const safetyFeedReport = (): SafetyFeedReport => report;

export function setSafetyFeedReport(next: SafetyFeedReport): void {
  report = next;
  for (const fn of listeners) fn();
}

export function clearSafetyFeedReport(): void {
  setSafetyFeedReport(empty());
}

export function subscribeSafetyFeed(fn: () => void): () => void {
  listeners.add(fn);
  return () => listeners.delete(fn);
}
